<template lang="pug">
b-modal#editBankMember(
  ref="editBankMember"
  :title="$t('ui.combine.edit_bank_member')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    //- small {{ getCurrencyCode }}
    b-form-group(:label="$t('ui.account_id')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="account_id"
        required
        alphaNum
        type="text"
        :dirty="$v.account_id.$dirty"
        :error="$v.account_id.$error"
        v-model.trim.lazy="$v.account_id.$model"
        :disabled="loading"
        :maxLength="$v.account_id.$params.maxLength.max"
      )
      ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
    b-form-group(:label="$tc('ui.banks', 1)").mb-0
      //- DebounceInput(
      //-   size="sm"
      //-   ref="bank"
      //-   required
      //-   type="text"
      //-   :dirty="$v.bank.$dirty"
      //-   :error="$v.bank.$error"
      //-   v-model.trim.lazy="$v.bank.$model"
      //-   :disabled="loading"
      //- )
      BankLookup(
        ref="bank"
        size="sm"
        required
        type="array"
        :dirty="$v.bank.$dirty"
        :error="$v.bank.$error"
        v-model.trim.lazy="$v.bank.$model"
        :disabled="loading"
        category="BANK"
        status=true
      )
      ValidateResult(:value="$v.bank" :name="$tc('ui.banks', 1)")
    template(v-if="item != null")
      b-form-group(:label="item.category != 'CRYPTO' ? $t('ui.bank_acc_no') : $t('ui.crypto_address')").mb-0
        DebounceInput(
          size="sm"
          required
          type="text"
          :dirty="$v.bank_acc_no.$dirty"
          :error="$v.bank_acc_no.$error"
          v-model.trim.lazy="$v.bank_acc_no.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.bank_acc_no" :name="item.category != 'CRYPTO' ? $t('ui.bank_acc_no') : $t('ui.crypto_address')")
      b-form-group(:label="item.category != 'CRYPTO' ? $tc('ui.bank_acc_holder', 1) : $t('ui.crypto_network')").mb-0
        template(v-if="item.category != 'CRYPTO'")
          DebounceInput(
            size="sm"
            ref="bank_acc_holder"
            required
            type="text"
            :dirty="$v.bank_acc_holder.$dirty"
            :error="$v.bank_acc_holder.$error"
            v-model.trim.lazy="$v.bank_acc_holder.$model"
            :disabled="loading"
          )
        template(v-else)
          CryptoNetworkLookup(
            ref="bank_acc_holder"
            size="sm"
            required
            type="array"
            :bankId="item.bank_id"
            :dirty="$v.bank_acc_holder.$dirty"
            :error="$v.bank_acc_holder.$error"
            v-model.trim.lazy="$v.bank_acc_holder.$model"
            :disabled="loading"
          )
        ValidateResult(:value="$v.bank_acc_holder" :name="item.category != 'CRYPTO' ? $tc('ui.bank_acc_holder', 1) : $t('ui.crypto_network')")
    template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
      b-form-group(:label="['AUD'].includes(getCurrencyCode) ? $t('ui.bsb') : $t('ui.cuit')").mb-0
        DebounceInput(
          size="sm"
          type="text"
          :dirty="$v.remark.$dirty"
          :error="$v.remark.$error"
          v-model.trim.lazy="$v.remark.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.remark" :name="['AUD'].includes(getCurrencyCode) ? $t('ui.bsb') : $t('ui.cuit')")
    template(v-if="['AUD'].includes(getCurrencyCode)")
      b-form-group(:label="$t('ui.payid')").mb-0
        DebounceInput(
          size="sm"
          type="text"
          :dirty="$v.payid.$dirty"
          :error="$v.payid.$error"
          v-model.trim.lazy="$v.payid.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.payid" :name="$t('ui.payid')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, requiredIf, maxLength, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import BankLookup from "@/library/BankLookup";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
import CryptoNetworkLookup from "@/library/CryptoNetworkLookup";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    BankLookup,
    CryptoNetworkLookup
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      account_id: "",
      bank: "",
      bank_acc_no: "",
      bank_acc_holder: "",
      remark: "",
      payid: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  validations: {
    account_id: {
      required,
      alphaNum,
      maxLength: maxLength(20)
    },
    bank: {
      required
    },
    bank_acc_no: {
      required,
    },
    bank_acc_holder: {
      required,
    },
    remark: {
      required: requiredIf(function () {
        return ['ARS','AUD'].includes(this.getCurrencyCode);
      }),
    },
    payid: {
      required: requiredIf(function () {
        return ['AUD'].includes(this.getCurrencyCode);
      }),
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.bankMemberUpdateUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          member_id: this.item.account_id,
          bank_id: this.item.bank_id.trim(),
          bank_acc_no: this.item.bank_acc_no.trim(),
          new_bank_id: this.bank.split(' - ')[0].trim(),
          new_bank_acc_no: this.bank_acc_no.trim(),
          new_bank_acc_holder: this.bank_acc_holder.trim(),
          new_remark: this.remark,
          new_remark_2: this.payid
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editBankMember.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_bank_account", this.feedback.status);
                  this.$refs.editBankMember.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.account_id = this.item.account_id;
      if(this.item.bank_id && this.item.bank_name) {
        this.bank = this.item.bank_id.trim().toUpperCase() + ' - ' + this.item.bank_name.trim().toUpperCase();
      }
      this.bank_acc_no = this.item.bank_acc_no;
      this.bank_acc_holder = this.item.bank_acc_holder;
      this.remark = this.item.remark;
      this.payid = this.item.remark_2;
      this.$refs.bank_acc_holder.$el.focus();
    }
  }
};
</script>
